export const keywordsFlow = [
  'CimmpleFlow',
  'Cimmple',
  'machine shop ERP',
  'CNC shop software',
  'CNC machine shop software',
  'job shop ERP',
  'job shop management software',
  'cloud ERP for manufacturing',
  'ERP for CNC shops',
  'manufacturing ERP',
  'machine shop operating system',
  'precision manufacturing software',
  'shop floor software',
  'quoting software for machine shops',
  'production tracking software',
  'job tracking software',
  'manufacturing inventory software',
  'quality traceability software',
  'shop accounting software',
  'VendorConnect',
  'AI invoice extraction',
];

export const keywordsPay = [
  'CimmplePay',
  'Cimmple',
  'payroll software',
  'payroll management software',
  'HR software',
  'HRIS',
  'payroll for small business',
  'employee payroll system',
  'payroll tax software',
  'pay stub software',
  'direct deposit payroll',
  'time and attendance software',
  'leave management software',
  'PTO tracking software',
  'employee self-service portal',
  'HR payroll platform',
  'multi-state payroll software',
];

export const keywordsRx = [
  'CimmpleRx',
  'Cimmple',
  'pharmacy ERP',
  'pharmacy ERP India',
  'pharmacy billing software',
  'medical shop software India',
  'medical store software',
  'chemist shop software',
  'GST pharmacy software',
  'pharmacy inventory software',
  'batch expiry tracking software',
  'pharmacy POS billing',
  'GST billing software for pharmacy',
  'medicine inventory software',
  'wholesale pharmacy software',
  'pharmacy accounting software',
];

export const keywordsServices = [
  'custom software development',
  'e-commerce website development',
  'web development services',
  'back-office data management',
  'invoice data entry services',
  'custom web applications',
];

export const productSeo: Record<
  string,
  {
    title: string;
    description: string;
    h1: string;
    headline: string;
    relatedTerms: string[];
  }
> = {
  cimmpleflow: {
    title: 'CimmpleFlow | Machine Shop ERP, CNC Job Shop & Manufacturing Software',
    description:
      'CimmpleFlow is machine shop ERP and cloud manufacturing software for CNC job shops—quoting software, production tracking, quality traceability, inventory, shop accounting, and AI invoice extraction.',
    h1: 'CimmpleFlow Machine Shop ERP',
    headline: 'Cloud manufacturing ERP for CNC shops, job shops, and precision manufacturers',
    relatedTerms: [
      'machine shop ERP',
      'CNC shop software',
      'job shop ERP',
      'quoting software for machine shops',
      'production tracking software',
      'manufacturing inventory software',
      'quality traceability software',
      'shop floor software',
    ],
  },
  cimmlepay: {
    title: 'CimmplePay | Payroll Software, HR & Employee Payroll System',
    description:
      'CimmplePay is payroll management software and HR software: payroll tax calculations, pay stubs, time and attendance, leave management, employee self-service, and payroll exports.',
    h1: 'CimmplePay Payroll Software',
    headline: 'Payroll management software, HRIS tools, and employee self-service for growing businesses',
    relatedTerms: [
      'payroll software',
      'payroll management software',
      'HR software',
      'payroll tax software',
      'pay stub software',
      'time and attendance software',
      'leave management software',
      'employee self-service portal',
    ],
  },
  cimmplerx: {
    title: 'CimmpleRx | Pharmacy ERP, Billing & Inventory Software for India',
    description:
      'CimmpleRx is pharmacy ERP for India: pharmacy billing software, GST invoicing, batch and expiry tracking, medicine inventory, purchases, and pharmacy accounting for medical shops and wholesalers.',
    h1: 'CimmpleRx Pharmacy ERP',
    headline: 'Pharmacy billing, GST, batch inventory, and medical shop software for India',
    relatedTerms: [
      'pharmacy ERP India',
      'pharmacy billing software',
      'medical shop software India',
      'GST pharmacy software',
      'pharmacy inventory software',
      'batch expiry tracking software',
      'pharmacy POS billing',
      'chemist shop software',
    ],
  },
};

export function joinKeywords(...groups: Array<string[] | undefined>): string {
  const seen = new Set<string>();
  const ordered: string[] = [];
  groups.flat().forEach((keyword) => {
    if (!keyword) return;
    const key = keyword.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    ordered.push(keyword);
  });
  return ordered.join(', ');
}

export const productKeywords: Record<string, string[]> = {
  cimmpleflow: keywordsFlow,
  cimmlepay: keywordsPay,
  cimmplerx: keywordsRx,
};
